"use client";
import * as React from "react";
import { useLocation } from "react-router";
import { Breadcrumb } from "../PageHeader/PageHeader";
import {
  getItemPath,
  getItemTitle,
  matchPath,
} from "../useNavigation/navigation";
import { useNavigation } from "../useNavigation/useNavigation";

export interface ActivePage {
  title: string;
  path: string;
  breadcrumbs: Breadcrumb[];
}

export function useActivePage(): ActivePage | null {
  const { navigation } = useNavigation();
  const { pathname } = useLocation();
  const activeItem = matchPath(navigation, pathname);

  const rootItem = matchPath(navigation, "/");

  return React.useMemo(() => {
    if (!activeItem) {
      return null;
    }

    const breadcrumbs: Breadcrumb[] = [];

    if (rootItem) {
      breadcrumbs.push({
        title: getItemTitle(rootItem),
        path: "/",
      });
    }

    const segments = pathname.split("/").filter(Boolean);
    let prefix = "";
    for (const segment of segments) {
      const path = `${prefix}/${segment}`;
      prefix = path;
      const item = matchPath(navigation, path);
      if (!item) {
        continue;
      }
      const itemPath = getItemPath(navigation, item);
      const lastCrumb = breadcrumbs[breadcrumbs.length - 1];
      if (lastCrumb?.path !== itemPath) {
        breadcrumbs.push({
          title: getItemTitle(item),
          path: itemPath,
        });
      }
    }

    return {
      title: getItemTitle(activeItem),
      path: getItemPath(navigation, activeItem),
      breadcrumbs,
    };
  }, [activeItem, rootItem, pathname, navigation]);
}
